(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('processed-patient-result', {
                parent: 'entity',
                url: '/processed-patient-result',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM],
                    pageTitle: 'Processed Patient Results'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/processed-patient-result/list/processed-patient-result.html',
                        controller: 'ProcessedPatientResultController',
                        controllerAs: 'vm'
                    }
                },
            });
    }
})();
